"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responsiveReferenceTitleStyles = exports.responsiveDescriptionStyles = exports.responsiveWordItemStyles = void 0;
const styled_components_1 = require("styled-components");
exports.responsiveWordItemStyles = (0, styled_components_1.css) `
  @media (max-width: 870px) {
    font-size: 30px;
    padding: 4px 15px;
  }

  @media (max-width: 540px) {
    font-size: 24px;
    padding: 3px 10px;
  }

  @media (max-height: 850px) {
    line-height: 16px;
  }

  @media (max-height: 744px) {
    line-height: 16px;
  }
`;
exports.responsiveDescriptionStyles = (0, styled_components_1.css) `
  @media (max-width: 850px) {
    font-size: 18px;
    padding: 4px 15px;
  }

  @media (max-width: 540px) {
    font-size: 18px;
    padding: 3px 10px;
    font-weight: 700;
  }
`;
exports.responsiveReferenceTitleStyles = (0, styled_components_1.css) `
  @media (max-width: 540px) {
    font-size: 18px;
    white-space: normal;
  }
`;
